import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './Footer.css';
import logo from '../assets/arcanes_new_home_logo.png';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <img src={logo} alt="ARCANES Logo" className="footer-logo" />
        <p className="footer-text">
          ARCANES Co., Ltd. specializes in AI commercialization consulting and AI Agent development.
        </p>
        <Link to="/about" className="footer-button">
          → VIEW MORE
        </Link>
      </div>
      <div className="footer-right">
        <h4 className="footer-heading">Contact</h4>
        <div className="footer-contact-item">
          <FiMapPin className="footer-icon" />
          <span>(16943) 314, Gwanggyojungang-ro, Suji-gu, Yongin-si, Gyeonggi-do, Republic of Korea, Unit 730</span>
        </div>
        <div className="footer-contact-item">
          <FiPhone className="footer-icon" />
          <span>(For development estimates and consulting) 010-3082-5149</span>
        </div>
        <div className="footer-contact-item">
          <FiMail className="footer-icon" />
          <a href="mailto:jyjowu@gmail.com">cto.jo@arcanes.ai</a>
        </div>
        <p className="footer-copy">
          © Copyright ARCANES Co., Ltd 2025. All Rights Reserved.
        </p>
      </div>
    </footer>
);
}
